module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/aiYRLF/tc-custom/9781398451216.jpg?1705766067163",
      "alt": "This image is the cover for the book An Impossible Quest"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("An Impossible Quest\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this story set in the ‘Dark Ages’ of British history, two brothers – twins Alfred and Leofric – help win a tribal conflict, but faced with ‘a fate worse than death’, they take to the road. They are seeking adventure and fame and are faced with opposition when Alfred falls in love with a beautiful (aren’t they all?) princess. He is challenged to complete a quest to prove he is worthy of her. That’s when the difficulties begin.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gordon S. Dickson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Gordon S. Dickson was born near Inverness, Scotland, but left at an early age when his family returned to Northern Ireland. "), _c('br'), _vm._v("He was educated at secondary and grammar schools, and scraped through English ‘O’ level, as essay writing was not his strength. "), _c('br'), _vm._v("He was employed in the civil service for several years but is now retired and has only recently taken up writing novels. An Impossible Quest: A Bartonshire Tale 2 is his latest novel. "), _c('br'), _vm._v("He enjoys reading several genres of books but mainly historical and detective novels, and gardening. "), _c('br'), _vm._v("Other books by this author are: "), _c('br'), _vm._v("Verdict Unknown "), _c('br'), _vm._v("The Sheriff of River Bend "), _c('br'), _vm._v("Des Pond, Special Agent "), _c('br'), _vm._v("The Wartime Adventures of Harry Harris "), _c('br'), _vm._v("– Bartonshire Tale 1 "), _c('br'), _vm._v("Verdict Unknown, the Sequel")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0